import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { ServerFields } from './ServerFields';
import { generateApiKey } from './generateApiKey';

const BACK_TO = '/system?tab=servers';

export const ServerCreate = () => (
  <Create actions={<FormPageTitle mode="create" />}>
    <SimpleForm
      toolbar={<FormToolbar backTo={BACK_TO} />}
      defaultValues={{ apiKey: generateApiKey(), isForcedOffline: false }}
    >
      <ServerFields mode="create" />
    </SimpleForm>
  </Create>
);
